import React, { useState } from "react";
import { Button, DialogContent, Divider } from "@mui/material";
import { Dialog, Typography, Stack, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ClipLoader } from "react-spinners";
import Repo from "../../Repository/Repo";
import CustomInput from "../../components/components/CustomInput";
import { Toast } from "../../components/components/Toast";

function AddStore({ onClose, onSuccess, store }) {
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    business: store ? store.storeName : "",
    address: store ? store.address : "",
    contact: store ? store.contactNo : "",
    description: store ? store.description : "",
    email: store ? store.email : "",
    userName: store ? store.userName : "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (name == "userName") {
      if (value.indexOf(" ") !== -1) {
        Toast("info", "Empty space not allowed in username");
        return;
      }
    } else {
      setState((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleClear = (arg) => {
    setState((prev) => ({ ...prev, [arg]: "" }));
  };
  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      let storeData = {
        company_code: localStorage.getItem("companyCode"),
        storeName: state.business,
        email: state.email,
        description: state.description,
        contactNo: state.contact,
        address: state.address,
        userName: state.userName,
      };
      if (store) {
        storeData._id = store._id;
        storeData._rev = store._rev;
      }

      let { data } = await Repo.store({
        request: {
          method: store ? "updateStore" : "saveStore",
          data: storeData,
        },
      });
      console.log(data);
      setLoading(false);
      onSuccess();
    } catch (err) {
      onClose();
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="xs">
      <DialogContent>
        <Typography sx={{ textAlign: "center", mb: 0.8 }}>
          Add your business details
        </Typography>
        <Divider sx={{ mb: "24px" }} />
        <Stack spacing="24px">
          <CustomInput
            name="business"
            label="Business Name"
            value={state.business}
            onChange={handleInput}
            onClick={() => handleClear("business")}
          />
          <CustomInput
            name="description"
            label="Business Description"
            value={state.description}
            onChange={handleInput}
            onClear={() => handleClear("description")}
          />
          <CustomInput
            name="address"
            label="Business Address"
            value={state.address}
            onChange={handleInput}
            onClear={() => handleClear("address")}
          />
          <CustomInput
            name="contact"
            label="Contact"
            type="number"
            value={state.contact}
            onChange={handleInput}
            onClear={() => handleClear("contact")}
          />
          <CustomInput
            name="email"
            label="Email Id"
            value={state.email}
            onChange={handleInput}
            onClear={() => handleClear("email")}
          />

          <CustomInput
            name="userName"
            label="Username"
            value={state.userName}
            onChange={handleInput}
            onClear={() => handleClear("userName")}
          />
          {loading && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <ClipLoader size={28} color="#4DAF51" loading={true} />
            </Box>
          )}
          {!loading && (
            <Button
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
              onClick={handleSubmit}
            >
              <CheckCircleIcon sx={{ mr: 2.4, color: "#fff" }} />{" "}
              {store ? "Update Store Info" : "Save Store Info"}
            </Button>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default AddStore;
